





import { Component, Prop, Vue } from 'vue-property-decorator'
import Chart, { ChartConfiguration } from 'chart.js'

@Component
export default class Doughnut extends Vue {
  @Prop({ default: [] }) readonly labels!: Array<string>
  @Prop({ default: [] }) readonly colors!: Array<string>
  @Prop({ default: '' }) readonly id!: string
  @Prop({
    default: () => {
      return [];
    }
  })
  readonly data!: Array<number>
  @Prop({
    default: () => {
      return Chart.defaults.doughnut
    }
  })
  private options: any | undefined

  private async mounted() {
    //this.options.legend.display = false; //hide labels
    this.createChart({
      datasets: [
        {
          data: this.data,
          backgroundColor: this.colors
        }
      ],
      labels: this.labels,
    });
  }

  private createChart(chartData: any) {
    const canvas = document.getElementById(this.id) as HTMLCanvasElement;
    const cfg : ChartConfiguration = {
      type: 'doughnut',
      data: chartData,
      options: this.options
    }
    new Chart(canvas, cfg)
  }
}

